export default __webpack_public_path__ + "static/media/Akustikdecken1.8b26fc9d.jpg";